export const routes = {
  onboardingRoutes: ["/login"],
  hideTopNavRoutes: ["/profile"],
  patientRoutes: [
    "/",
    "/home",
    "/find-doctor",
    "/medicines",
    "/test-reports",
    "/health-hub",
    "/health-hub/video",
    "/health-hub/blog-list",
    "/health-hub/playlist",
    "/health-hub/blog",
    "/health-hub/disease",
    "/doctor-profile",
    "/faq",
    "/chat",
    "/about-us",
    "/contact-us",
    "/app-feature",
    "/partner-with-us",
    "/privacy-policies",
    "/terms-conditions",
  ],
  routesWithoutNavsOnMobile: [
    "/health-hub/video",
    "/health-hub/blog",
    "/health-hub/disease",
    "/health-hub/playlist",
    "/health-hub/blog-list",
    "/faq",
    "/doctor-profile",
    "/chat",
  ],
  routesWithoutNavsOnTablet: ["/faq", "/doctor-profile", "/chat"],
  doctorRoutes: ["/schedule", "/ip-dash", "/chats", "/profile"],
  doctorBottomNavRoutes: ["/schedule", "/ip-dash", "/chats", "/profile"],
  pharmacyTopNavRoutes: ["/orders", "/clinic-patient"],
  hideDoctorOrJrDoctorTopFooterRoutes: ["/join-room", "/reports"],
  termConditionPrivacyPolicy: ["/privacy-policies", "/terms-conditions"],
};
